import { SiteConfig } from '../config/siteConfig';

export const initializeMatomoAnalytics = () => {
  // Check if Matomo Tag Manager is already initialized
  if (window._mtm) {
    return;
  }

  // Initialize _mtm array for Tag Manager
  window._mtm = window._mtm || [];
  
  // Push start event
  const startEvent = {'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'};
  window._mtm.push(startEvent);
  
  // Get container name from config, fallback to default
  const containerName = SiteConfig.MatomoContainerName || 'container_j4phrRIC';
  const scriptUrl = `https://cdn.matomo.cloud/engie.matomo.cloud/${containerName}.js`;

  // Create and inject script tag (external script, CSP-compliant)
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = scriptUrl;

  // Insert script into document head
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);
};

export const trackPageView = (customTitle) => {
  if (!window._mtm) {
    return;
  }

  const pageData = {
    'event': 'mtm.PageView'
  };

  if (customTitle) {
    pageData['mtm.PageTitle'] = customTitle;
  }

  window._mtm.push(pageData);
};

export const trackEvent = (category, action, name, value) => {
  if (!window._mtm) {
    return;
  }

  const eventData = {
    'event': 'mtm.Event',
    'mtm.EventCategory': category,
    'mtm.EventAction': action
  };

  if (name) {
    eventData['mtm.EventName'] = name;
  }

  if (value !== undefined) {
    eventData['mtm.EventValue'] = value;
  }

  window._mtm.push(eventData);
};

const matomoAnalytics = {
  initializeMatomoAnalytics,
  trackPageView,
  trackEvent,
};

export default matomoAnalytics;
